import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { LoginAutomatico } from '@/features/login/page/LoginAutomatico';

export const Route = createFileRoute('/auth/login-automatico')({
    component: LoginAutomaticoRoute,
    validateSearch: z.object({ encode: z.string() }),
});

function LoginAutomaticoRoute() {
    const { encode } = Route.useSearch();

    return <LoginAutomatico encode={encode} />;
}
